let firstBy = require("thenby");

const I18N = {
  en: require('../../public/static/i18n/en').default,
  th: require('../../public/static/i18n/th').default,
  zh: require('../../public/static/i18n/zh').default
}
import { isString, sortObjectArray } from "./utils";
import store from '../store';

export function getLanguage() {
  // todo: provide a way for getting language from UI
  let lang = 'th';
  if (store && store.getters && store.getters.User) {
    lang = store.getters.User.Language;
  } else if (navigator) {
    lang = navigator.language.split('-')[0];
  }
  if (!lang.match(/^th$|^en$|^zh$/i)) {
    lang = 'en';
  }
  return lang.toLowerCase();
}

let flatten = arr => arr.reduce((a, b) => a.concat(Array.isArray(b) ? this.flatten(b) : b), []);
function strRender(str, char, ...replacers) {
  replacers = flatten(replacers);
  var res = str;
  replacers.forEach(function(replacer) {
    res = res.replace(char, replacer)
  });
  return res;
}

export function transformString(key, args?:any[]) {
  if (!key) return key + '';
  let language = getLanguage();
  let strings = I18N[language] || {};
  let res = '';
  if (Array.isArray(key)) {
    let lastV = '';
    let n = key.length;
    key.forEach((k) => {
      let v;
      let inDict;
      let isEn = !!language.match(/^en$/i);
      let asIt = false;
      k += '';
      try {
        if (k.substr(0,1)=='^' && (k.substr(k.length-1)=='$')) {
          asIt = true;
          k = k.substr(1,k.length-2);
        }
        inDict = strings.hasOwnProperty(k);
        v = k.match(/^&s$/i) ? (isEn ? ' ' : '') : (inDict ? strings[k] : k);
        if (isEn && inDict && v) {
          v = asIt ? v : ((!res) || !lastV || lastV.match(/^\.$|^!$|^\?$|^\/$|^\\$|^\|$|^"$|^'$|^-\s/)) ? 
              (v.substr(0,1).toUpperCase() + v.substr(1).toLowerCase()) : v.toLowerCase();
          //prepend or append a space to the word
          if (n==1) {
            v += ' ';
          } else {
            v = ((!res || lastV.match(/^\/$|^\\$|^\|$|^"$|^'$|\s$/) || 
                v.match(/^\/$|^\\$|^\|$|^,|^\s/) || (v.match(/^"$|^'$/) && lastV)) ? 
                '' : ' ') + v; //prepend a space
          }
          res += v;
        } else {
          res += v;
        }
        lastV = v;
      } catch (e) {
      }
    }, this);
  } else {
    res = strings.hasOwnProperty(key) ? strings[key] : key;
  }
  if (args) {
    let params:string[] = args.map((arg) => {
      if (arg instanceof Date) {
        return transformDateTimeText(arg, false);
      } else {
        return transformString(arg);
      }
    });
    res = strRender(res, '%s', ...params);
  }

  return res;
}

export function daysBeforeToday(date) {
  if (!date) {
    return 0;
  }
  let today = new Date();
  let theDate = new Date(date.getTime()); //clone it
  today.setHours(0,0,0,0);
  theDate.setHours(0,0,0,0);
  return (today.getTime() - theDate.getTime()) / (24*60*60*1000); //ms to day
}

export function transformDateFull(date) {
  if (!date) {
    return '';
  }
  let months = L('monthsText');
  let weekDays = L('weekDaysText');

  let d;
  let yy = date.getFullYear(); //2017
  let mm = date.getMonth();
  let dd = date.getDate();
  let wd = date.getDay();
  let language = getLanguage();
  switch (language) {
  case 'th':
    d = L('day') + weekDays[wd] + ', ' + dd + ' ' + months[mm] + ' ' + (yy + 543);
    break;
  case 'zh':
    d  = yy + '' + L('year');
    d += '' + (mm+1) + '' + L('month');
    d += '' + dd + '' + L('day') + ', ' + weekDays[wd];
    break;
  case 'en':
  default:
    d = weekDays[wd] + ', ' + months[mm] + ' ' + dd + ', ' + yy;
  }
  return d;
}

export function transformDateTimeText(date, hasTime?:boolean) {
  if (!date) {
    return '';
  }
  let months = L('monthsText');
  let d = '';
  let yy = date.getFullYear(); //2017
  let mm = date.getMonth();
  let dd = date.getDate();
  // let wd = date.getDay();
  let th = date.getHours() + '';
  let tm = date.getMinutes() + '';
  let language = getLanguage();
  
  switch (language) {
  case 'th':
    th = ('0' + th).slice(-2);
    tm = ('0' + tm).slice(-2);
    d = 'วันที่ ' + dd + ' ' + months[mm] + ' ' + (yy + 543); //+ ' พ.ศ. ' + (yy + 543);
    if (hasTime!==false) {
      d += ' เวลา ' + th + ':' + tm + 'น.';
    }
    break;
  case 'zh':
    d  = yy + '' + L('year') + '' + (mm+1) + '' + L('month') + '' + dd + '' + L('day');
    if (hasTime!==false) {
     d += th + '点' + tm + '分';
    }
    break;
  case 'en':
  default:
    th = ('0' + th).slice(-2);
    tm = ('0' + tm).slice(-2);
    if (hasTime!==false) {
      d = th + ':' + tm + ' on ' 
    }
    d += months[mm] + ' ' + dd + ', ' + yy;
  }
  return d;
}

export function transformDateFormatted(date, f) {
  if (!date) {
    return '';
  }
  let months = L('monthsText');
  let language = getLanguage();
  let z = {
    y: date.getFullYear() + ((language=='th') ? 543 : 0),
    M: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    amPm: ''
  }
  f = (f || 'yyyy-MM-dd').trim().replace('mmm','MMM');
  if (f.match(/h|m|s/) && (f.indexOf(' 12h')==f.length-4)) {
    f = f.substr(0,(f.length-4)).trim(); //IMPORTANT to remove ' 12h'
    if (z.h < 12) {
      z.amPm = ' ' + L('timeAm');
    } else {
      z.h -= 12;
      z.amPm = ' ' + L('timePm');
    }
  }
  //swap yyyy-MM-dd to dd-MM-yyyy, if not, yyyy-MM to MM-yyyy, then MM-dd to dd-MM
  if (language=='th') {
    // force to mm-dd-yy
    f = f.replace(/(y+)(-|\/|\s)(M+)(-|\/|\s)(d+)/g,'$5$2$3$4$1')
         .replace(/(y+)(-|\/|\s)(M+)/g,'$3$2$1')
         .replace(/(M+)(-|\/|\s)(d+)/g,'$3$2$1');
  } else if (language=='zh') {
    // force to yy-mm-dd
    f = f.replace(/(d+)(-|\/|\s)(M+)(-|\/|\s)(y+)/g,'$5$2$3$4$1')
         .replace(/(M+)(-|\/|\s)(y+)/g,'$3$2$1')
         .replace(/(d+)(-|\/|\s)(M+)/g,'$3$2$1');
    f = f.replace(/\s/g,'');
    if (f.indexOf('MMM')>=0 && f.match(/d$/i)) {
      f += L('day');
    }
  } else {
    if (f.indexOf('MMM')>0) {
      f = f.replace(/(y+)(-|\/|\s)(M+)(-|\/|\s)(d+)/g,'$3$2$5$4,$1')
           .replace(/(y+)(-|\/|\s)(M+)/g,'$3$2$1')
           .replace(/(d+)(-|\/|\s)(M+)/g,'$3$2$1');
    } else {
      f = f.replace(/(d+)(-|\/|\s)(M+)(-|\/|\s)(y+)/g,'$5$2$3$4$1')
           .replace(/(M+)(-|\/|\s)(y+)/g,'$3$2$1')
           .replace(/(d+)(-|\/|\s)(M+)/g,'$3$2$1');
    }
  }
  return f.replace(/(y+|M+|d+|h+|m+|s+)/g, (v) => {
      if (v=='MMM') {
        return months[z.M-1];
      } else {
        return (!!f.match(/-|\/|:/) && v.length>1) ? ('0' + z[v.slice(-1)]).slice(-v.length) : z[v.slice(-1)];
      }
  }) + z.amPm;
}

export function transformDateRecent(date, format)  {
  if (!date) {
    return '';
  }

  let s;

  let dn = daysBeforeToday(date);
  let z = {
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    w: date.getDay(),
    amPm: ''
  }

  if (dn==0) {
    if (format && format.indexOf('d')>=0) {
        s = L('today');
    } else {
      /*if (z.h < 12) {
        z.amPm = ' ' + L('timeAm');
      } else {
        z.h -= 12;
        z.amPm = ' ' + L('timePm');
      }
      s = 'h:m'.replace(/(h+|m+)/g, (v) => {
        return (v.length > 1) ? ('0' + z[v.slice(-1)]).slice(-v.length) : z[v.slice(-1)];
      }) + z.amPm;*/
      dn = ((new Date()).getTime() - date.getTime()) / 3600000; //hsr
      if (dn>=1) {
        s = Math.floor(dn) + L('hour');
      } else {
        s = Math.ceil(dn * 60) + L('minute');
      }
      s = L([s,'','ago']);
    }
  } else if (dn==1) {
    s = L('yesterday');
  } else if (dn<=7) {
    let weekDays = L('weekDaysText');
    s = weekDays[z.w];
  } else {
    let thisYear = new Date().getFullYear();
    if (date.getFullYear() == thisYear) {
      if (format && format.indexOf('y')!=-1) {
        //to get month and day only
        if (format.indexOf('d')==-1) {
          format = format.replace(/y+/g,'dd'); //replace year to date
        } else {
          format = format.replace(/y+(-|\/|\s)/g,''); //remove year
        }
      } else if (!format) {
        format = 'MMM dd';
      }
      s = transformDateFormatted(date,format);
    } else {
      if (!format) {
        format = 'MMM/yyyy';
      }
      s = transformDateFormatted(date,format);
    }
  }
  return s;
}

export function transformDate(date, format) {
  if (!date) {
    return '';
  }
  if (format) {
    if (format.match(/^recent/i)) {
      let i = format.indexOf(',');
      if (i>0) {
        format = format.substr(i+1);
      } else {
        format = null;
      }
      return transformDateRecent(date,format);
    } else {
      return transformDateFormatted(date, format);
    }
  } else {
    return transformDateFull(date);
  }
}

export function transformAge(date) {
  //todo
  let today = new Date();
  let age = today.getTime() - date.getTime();
  let year = today.getFullYear() - date.getFullYear();

}

export const L = transformString;
export const D = transformDate;
export const DT = transformDateTimeText;
export const S = sortObjectArray;
export default {
  L: L,
  D: D,
  DT: DT,
  S: S
}
